import { z } from 'zod';

export const adminsControllerCreate201Schema = z.string();

export const adminsControllerCreate400Schema = z.object({
  statusCode: z.enum(['400']),
  message: z.string(),
  type: z.enum(['InvalidData']),
  details: z.object({
    location: z.enum(['path', 'query', 'body']),
    explanation: z.object({
      issues: z.array(
        z
          .object({
            code: z.enum([
              'invalid_type',
              'invalid_literal',
              'custom',
              'invalid_union',
              'invalid_union_discriminator',
              'invalid_enum_value',
              'unrecognized_keys',
              'invalid_arguments',
              'invalid_return_type',
              'invalid_date',
              'invalid_string',
              'too_small',
              'too_big',
              'invalid_intersection_types',
              'not_multiple_of',
              'not_finite',
            ]),
            path: z.array(z.union([z.string(), z.number()])),
            message: z.string(),
          })
          .catchall(z.unknown()),
      ),
    }),
  }),
});

export const adminsControllerCreate401Schema = z.object({
  statusCode: z.enum(['401']),
  message: z.string(),
  type: z.enum(['Authentication']),
  details: z.object({
    reason: z.enum(['InvalidRequest', 'InvalidToken', 'Unauthorized']),
  }),
});

export const adminsControllerCreate403Schema = z.object({
  statusCode: z.enum(['403']),
  message: z.string(),
  type: z.enum(['Authorization']),
  details: z.object({ reason: z.enum(['InsufficientScope']) }),
});

export const adminsControllerCreate409Schema = z.object({
  statusCode: z.enum(['409']),
  message: z.string(),
  type: z.enum(['UniqueViolation']),
  details: z.object({ attributes: z.array(z.string()) }),
});

export const adminsControllerCreateMutationRequestSchema = z.object({
  auth0Id: z.string(),
  firstName: z.string().min(2).max(64),
  lastName: z.string().min(2).max(64),
  email: z.string().email(),
  backupEmail: z.string().email().optional().nullable(),
  phoneNumber: z.string().optional().nullable(),
  username: z.string().optional().nullable(),
  avatar: z.string().optional().nullable(),
  description: z.string().min(3).max(255).optional().nullable(),
  timeZone: z.string().optional().nullable(),
  password: z.string().min(8).max(32).optional().nullable(),
});

export const adminsControllerCreateMutationResponseSchema = z.string();
